import { debounce } from "../../utils/performance";
import { createElement, removeChildren } from "../../utils/DOMutils";
import { getDocs, highlightSearchQuery } from "../../vue/search/utils";
import { getSearchInputElements, handleSearchInput, handleSearchReset } from "../../utils/searchInput";

export default function(el) {
    const statusMessageEl = el.querySelector(".status-message");
    const statusMessageTextEl = statusMessageEl && statusMessageEl.querySelector(".status-message__text");
    const resultsEl = el.querySelector(".search__results");
    const [searchInput, inputEl, resetButtonEl] = getSearchInputElements(el);
    const restUrl = el.dataset.restUrl;
    const messages = el.dataset.messages && JSON.parse(el.dataset.messages);

    const state = {
        searchQuery: null,
        results: [],
        errorMessage: null,
    };

    const createResultEl = (name, link) => {
        const highlightedName = highlightSearchQuery(name, state.searchQuery);
        const listItemEl = createElement("li", { class: "search__item" });
        const linkEl = createElement("a", {
            class: "search__result-title",
            href: link,
            target: "_blank",
            rel: "noopener noreferrer",
        });

        linkEl.innerHTML = highlightedName;

        listItemEl.appendChild(linkEl);

        return listItemEl;
    };

    const appendResults = () => {
        const resultsListEl = createElement("ul", { class: "search__list" });

        for (const result of state.results) {
            if (!result.url || !result.title) continue;

            const listItemEl = createResultEl(result.title, result.url);

            resultsListEl.appendChild(listItemEl);
        }

        resultsEl.appendChild(resultsListEl);
    };

    const handleInput = debounce((e) => {
        state.searchQuery = e.target.value;

        if (state.searchQuery.length === 0) return resetState();

        getDocs(restUrl, state.searchQuery, true)
            .then((docs) => {
                resetState();

                if (docs.length === 0) return setErrorMessage("noDocs");

                state.results = docs.slice(0, 5);
                appendResults();
            })
            .catch((err) => setErrorMessage("server"));
    }, 300);

    const resetState = () => {
        state.results = [];
        removeChildren(resultsEl);
        setErrorMessage();
    };

    const setErrorMessage = (type = null) => {
        if (!statusMessageEl || !statusMessageTextEl || (!type && !state.errorMessage)) return;

        state.errorMessage = type && messages && messages[type] && messages[type];
        statusMessageTextEl.innerText = state.errorMessage;
        statusMessageEl.classList[state.errorMessage ? "add" : "remove"]("status-message--active");
    };

    if (!inputEl || !resultsEl || !restUrl) return;

    inputEl.addEventListener("input", handleInput);

    if (resetButtonEl) {
        if (searchInput)
            inputEl.addEventListener(
                "input",
                handleSearchInput.bind(null, searchInput, "search-input--filled")
            );

        resetButtonEl.addEventListener("click", handleSearchReset.bind(null, inputEl));
    }
}
